import { getSessionDataFromSessionStorage } from 'bootstrap/lib/getSessionDataFromSessionStorage';
import { listenMessageFromExtension } from './listenMessageFromExtension';
import { MessageResponseTypes } from '../schema/ResponseMessageTypes';
import { SessionData } from 'owa-service/lib/types/SessionData';
import { storeSessionDetailsInSessionStorage } from 'bootstrap/lib/storeSessionDetailsInSessionStorage';
import {
    getFindConversationDataFromSessionStorage,
    getFindFoldersDataFromSessionStorage,
    getFindMailItemsDataFromSessionStorage,
    setFindConversationDataInSessionStorage,
    setFindFoldersDataInSessionStorage,
    setFindMailItemsDataInSessionStorage,
} from 'mini-mail-session-storage-data';

export const initializeBootDataListener = () => {
    listenMessageFromExtension(event => {
        if (event.data.type !== MessageResponseTypes.MailStartupData) {
            return;
        }

        // Store the data in sessionStorage for the rebootstrap flow to pick data from there
        const { startupData }: { startupData: SessionData } = event.data.payload;
        const { findConversation, findMailFolderItem, findFolders } = startupData;

        if (!getSessionDataFromSessionStorage() && startupData) {
            // Store session info against 'session' key in sessionStorage
            storeSessionDetailsInSessionStorage(startupData);
        }

        // Store data only if data is not already stored in sessionStorage
        // NOTE: Presence of data in sessionStorage means current browser session is active and user is coming back to
        // mail module through module switching
        if (!getFindFoldersDataFromSessionStorage() && findFolders) {
            setFindFoldersDataInSessionStorage(findFolders);
        }

        if (!getFindConversationDataFromSessionStorage() && findConversation) {
            setFindConversationDataInSessionStorage(findConversation);
        }

        if (!getFindMailItemsDataFromSessionStorage() && findMailFolderItem) {
            setFindMailItemsDataInSessionStorage(findMailFolderItem);
        }
    });
};
